// extracted by mini-css-extract-plugin
export default {"sprite":"Sprite_sprite__rWmc-"};